/** Strip HTML from YouTube API error messages for safe display in the UI. */
export function sanitizeBannerWorkerError(raw: string | undefined): string {
  if (!raw?.trim()) {
    return "—";
  }
  return raw
    .replace(/<a\b[^>]*>/gi, "")
    .replace(/<\/a>/gi, "")
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, " ")
    .trim();
}
